import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Action, Page } from '@/../../server/types/loggingTypes';
import InboxV0 from '@/components/Inbox/InboxV0';
import InboxV1 from '@/components/Inbox/InboxV1';
import { useGate } from '@/hooks/useGate';
import { getStatsigClient } from '@/utils/statsig';

export const Route = createFileRoute('/_privateRoutes/_mainNavBar/inbox')({
  component: Inbox,
});

export default function Inbox() {
  const checkGate = useGate('inbox_v1');

  useEffect(() => {
    getStatsigClient().logEvent(Page.INBOX_TAB, Action.VIEW);
  }, []);

  if (!checkGate()) {
    return <InboxV0 />;
  }

  return <InboxV1 />;
}
